import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";
import IdpGroupAutocompleteCell from "../IdpGroupAutocompleteCell";
import { ScimWizardRoleNameCell } from "../styled/scim-wizard.styled";

export const getStep6GroupColumns = (
	identityProviderName,
	idpGroups,
	mappedGroups,
	setMappedGroups,
	apiRef,
	initializeExternalGroups,
	setIdpGroups,
	toggleEditGroupDialog,
	toggleDeleteGroupDialog
) => [
	{
		field: "name",
		headerName: "CoApp groups",
		sortable: true,
		flex: 1,
		renderCell: (params) => <ScimWizardRoleNameCell variant="body2" noWrap={true}>{params.value}</ScimWizardRoleNameCell>
	},
	{
		field: "idpGroups",
		headerName: `${identityProviderName} groups`,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<IdpGroupAutocompleteCell
				options={idpGroups}
				mapped={mappedGroups}
				setMapped={setMappedGroups}
				resourceName={params.row.name}
				apiRef={apiRef}
				initializeGroupOptions={initializeExternalGroups}
				setExternalGroups={setIdpGroups}
			/>
		)
	},
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params) => (
			<div>
				<ThreeDotMenu
					options={[
						{
							name: "Edit",
							optionClickHandler: () => {
								toggleEditGroupDialog(params.row);
							},
						},
						{
							name: "Delete",
							optionClickHandler: () => {
								toggleDeleteGroupDialog(params.row);
							},
						},
					]}
				/>
			</div>
		)
	}
];